/* Shopify plafón registrable printing: existing quote, optional Proyecta views.
   Mirrors presupuesto-corrido-print.js. The calculator stays the source of
   quantities and prices. When the visitor includes the views, an offscreen
   iframe loads /plafon-registrable?quotePrint=1 and returns six PNGs. */
(() => {
  if (window.altaRegistrablePrintInstalled) return;
  const button = document.querySelector('.registrable-usg-page .registrable-usg-print-button');
  const form = document.forms.namedItem('cuadricula');
  if (!button || !form || typeof window.buildRegistrablePrintHtml !== 'function' ||
      typeof window.syncRegistrableSummary !== 'function') return;
  window.altaRegistrablePrintInstalled = true;

  const origin = 'https://proyecta.altamateriales.com.mx';
  // Shopify option order, mapped onto Proyecta tile ids. Astral and Solar share
  // one storefront option; the illustrative model uses Astral.
  const tileIds = [
    'frost-414',
    'glaciar-707',
    'sandrift-808',
    'fissured-506',
    'radar-2202-requested',
    'olympia-4221',
    'eclipse-76775',
    'mars-86785',
    'millenia-76705',
    'radar-2410',
    'fissured-562',
    'astral',
    'clean-room-56091a',
    'sheetrock-3270',
  ];

  const controls = document.createElement('div');
  controls.className = 'alta-registrable-print-controls';
  const label = document.createElement('label');
  const checkbox = document.createElement('input');
  checkbox.type = 'checkbox';
  checkbox.checked = true;
  checkbox.id = 'alta-registrable-include-views';
  label.append(checkbox, ' Incluir las seis vistas del sistema en la impresión');
  const status = document.createElement('div');
  status.className = 'alta-registrable-print-status';
  status.setAttribute('role', 'status');
  status.setAttribute('aria-live', 'polite');
  const spinner = document.createElement('span');
  spinner.className = 'alta-registrable-print-spinner';
  spinner.setAttribute('aria-hidden', 'true');
  const message = document.createElement('span');
  status.append(spinner, message);
  status.hidden = true;
  controls.append(label, status);
  form.prepend(controls);

  const uiStyle = document.createElement('style');
  uiStyle.textContent = `
    .alta-registrable-print-controls{padding:12px 0;font-size:14px}
    .alta-registrable-print-controls label{display:flex;align-items:center;gap:8px;cursor:pointer}
    .alta-registrable-print-controls input{width:18px;height:18px;accent-color:#12385f;flex-shrink:0}
    .alta-registrable-print-status{display:flex;align-items:center;gap:10px;margin-top:10px;color:#12385f}
    .alta-registrable-print-status[hidden]{display:none}
    .alta-registrable-print-spinner{width:22px;height:22px;border:3px solid #d8e1ee;border-top-color:#12385f;border-radius:50%;animation:alta-registrable-spin .8s linear infinite;flex-shrink:0}
    .alta-registrable-print-spinner[hidden]{display:none}
    @keyframes alta-registrable-spin{to{transform:rotate(360deg)}}
    @media(prefers-reduced-motion:reduce){.alta-registrable-print-spinner{animation-duration:2s}}
    @media print{.alta-registrable-print-controls{display:none}}
  `;
  document.head.append(uiStyle);

  let printFrame = null;
  let cachedViews = null;
  let busy = false;

  function makeFrame(title) {
    const frame = document.createElement('iframe');
    frame.title = title;
    frame.tabIndex = -1;
    frame.setAttribute('aria-hidden', 'true');
    frame.style.cssText = 'position:fixed;left:-10000px;top:0;width:1200px;height:900px;border:0;pointer-events:none';
    return frame;
  }

  function selectedTile() {
    const select = form.elements.namedItem('ddlPlaca');
    const index = select && 'selectedIndex' in select ? select.selectedIndex : 0;
    return tileIds[index] || tileIds[0];
  }

  function selectedProductName() {
    const select = form.elements.namedItem('ddlPlaca');
    const option = select && 'options' in select ? select.options[select.selectedIndex] : null;
    return option ? option.text.trim() : 'Plafón registrable';
  }

  async function getViews(length, width, tile) {
    const key = `${length}x${width}:${tile}`;
    if (cachedViews?.key === key) return cachedViews.images;
    const frame = makeFrame('Generador de vistas del plafón registrable');
    // Offscreen cross-origin frames may have animation callbacks paused.
    frame.style.cssText = 'position:fixed;left:0;top:0;width:100vw;height:100vh;border:0;opacity:0.01;pointer-events:none;z-index:-1';
    const requestId = crypto.randomUUID();
    try {
      const images = await new Promise((resolve, reject) => {
        const cleanup = () => {
          clearInterval(retry);
          clearTimeout(timeout);
          window.removeEventListener('message', receive);
        };
        const receive = event => {
          if (event.origin !== origin || event.source !== frame.contentWindow ||
              event.data?.requestId !== requestId) return;
          if (event.data.type === 'alta:quote-views:error') {
            cleanup(); reject(new Error('No se pudieron generar las vistas.')); return;
          }
          if (event.data.type !== 'alta:quote-views:result') return;
          const images = event.data.images;
          if (!Array.isArray(images) || images.length !== 6 ||
              !images.every(image => typeof image.name === 'string' &&
                typeof image.url === 'string' && image.url.startsWith('data:image/png;base64,'))) return;
          cleanup(); resolve(images);
        };
        const retry = setInterval(() => frame.contentWindow?.postMessage({
          type: 'alta:quote-views:request', requestId,
        }, origin), 1000);
        const timeout = setTimeout(() => {
          cleanup(); reject(new Error('No se pudieron preparar las vistas a tiempo. Puedes desmarcarlas para imprimir solo el presupuesto.'));
        }, 60000);
        window.addEventListener('message', receive);
        const params = new URLSearchParams({
          quotePrint: '1',
          length: String(length),
          width: String(width),
          tile,
        });
        frame.src = `${origin}/plafon-registrable?${params.toString()}`;
        document.body.append(frame);
      });
      cachedViews = { key, images };
      return images;
    } finally { frame.remove(); }
  }

  button.removeAttribute('onclick');
  button.addEventListener('click', async () => {
    if (busy) return;
    const length = Number(form.elements.namedItem('txtLargo').value);
    const width = Number(form.elements.namedItem('txtAncho').value);
    const includeViews = checkbox.checked;
    status.hidden = false;
    spinner.hidden = false;
    if (!includeViews) {
      status.hidden = true;
      window.syncRegistrableSummary();
      window.printRegistrableUSG();
      return;
    }
    if (![length, width].every(n => Number.isFinite(n) && n >= 0.5 && n <= 20)) {
      spinner.hidden = true;
      message.textContent = 'Para incluir las seis vistas, ingresa largo y ancho entre 0.50 y 20 m.';
      return;
    }
    busy = true;
    button.disabled = true;
    checkbox.disabled = true;
    button.setAttribute('aria-busy', 'true');
    message.textContent = 'Preparando presupuesto y seis vistas…';
    const tile = selectedTile();
    const productName = selectedProductName();
    let nextFrame = null;
    try {
      window.syncRegistrableSummary();
      const html = window.buildRegistrablePrintHtml();
      const images = await getViews(length, width, tile);
      printFrame?.remove();
      nextFrame = makeFrame('Presupuesto para impresión');
      document.body.append(nextFrame);
      const printWindow = nextFrame.contentWindow;
      const doc = printWindow.document;
      doc.open();
      doc.write(html);
      doc.close();
      const style = doc.createElement('style');
      style.textContent = `
        /* The quote watermark is position:fixed, so it was reprinting huge on the views page. Keep it inside the quote sheet only. */
        .print-budget-shell{position:relative !important}
        .print-budget-watermark{position:absolute !important;top:46% !important}
        .alta-quote-views{break-before:page;padding:8px 12px 16px;max-width:960px;margin:0 auto;background:#fff}
        .alta-quote-views h2{font-size:18px;color:#12385f;margin:0 0 4px}
        .alta-quote-views p{font-size:11px;color:#4a6079;margin:0 0 8px}
        .alta-quote-view-grid{display:grid;grid-template-columns:1fr 1fr;gap:8px}
        .alta-quote-view-grid figure{margin:0;break-inside:avoid}
        .alta-quote-view-grid figure:first-child,
        .alta-quote-view-grid figure.alta-quote-view-measured{grid-column:1 / -1}
        .alta-quote-view-grid img{width:100%;display:block;background:#fff}
        .alta-quote-view-grid figcaption{text-align:center;font-size:11px}
      `;
      doc.head.append(style);
      const section = doc.createElement('section');
      section.className = 'alta-quote-views';
      const heading = doc.createElement('h2');
      heading.textContent = `Plafón registrable · ${productName} · ${length.toFixed(2)} × ${width.toFixed(2)} m`;
      const note = doc.createElement('p');
      note.textContent = 'Vistas desde el interior, mirando hacia el plafón. La vista Proyecto con medidas muestra el largo y el ancho. Sin escala. Caída de referencia: 0.50 m.';
      const grid = doc.createElement('div');
      grid.className = 'alta-quote-view-grid';
      images.forEach(image => {
        const figure = doc.createElement('figure');
        // The measured overview should use the full page width, same as the interior hero.
        if (image.name === 'Proyecto con medidas') figure.className = 'alta-quote-view-measured';
        const img = doc.createElement('img');
        img.src = image.url;
        img.alt = `Vista ${image.name}`;
        const caption = doc.createElement('figcaption');
        caption.textContent = image.name;
        figure.append(img, caption);
        grid.append(figure);
      });
      section.append(heading, note, grid);
      doc.body.append(section);
      let readyTimeout;
      try {
        await Promise.race([
          Promise.all([...doc.images].map(img => img.decode().catch(() => {}))),
          new Promise((_, reject) => {
            readyTimeout = setTimeout(() => reject(new Error('No se pudieron cargar las imágenes de impresión.')), 20000);
          }),
        ]);
      } finally { clearTimeout(readyTimeout); }
      status.hidden = true;
      printFrame = nextFrame;
      printWindow.focus();
      printWindow.print();
    } catch (error) {
      nextFrame?.remove();
      spinner.hidden = true;
      status.hidden = false;
      message.textContent = `${error.message} Vuelve a intentar.`;
    } finally {
      busy = false;
      button.disabled = false;
      checkbox.disabled = false;
      button.removeAttribute('aria-busy');
      button.focus({ preventScroll: true });
    }
  });
})();
